import {useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/lootbox/state/preview';
import {openLoot} from '../../../../reducers/lootbox/actions';
import Diamond from '../diamond';
import BlueButton from '../../../components/blue-button';

export default () => {
    const {box, button} = useSelector(Selector),
          dispatch = useDispatch(),
          line = useRef();

    const resizeHandler = () => {
        if(box) {
            if(box.state === "preview") {
                const line_center = document.querySelector('.line-fix').offsetWidth / 2,
                      item_width = document.querySelector('.line .item').offsetWidth,
                      margin_width = 5;

                const items_left = Math.ceil(line_center / (item_width + margin_width)),
                      left = (item_width * items_left) + (margin_width * items_left) - line_center + (item_width / 2);

                if(line.current)
                    line.current.style.transform = `translate3d(-${left}px, 0, 0)`;
            }
        }
    }

    // Screen resize handler
    useEffect(() => {
        resizeHandler();

        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, [box]);

    return (
        <>
            <div className={`items-line`}>
                <div className="line-preview">
                    <img src={`${window.location.origin}/source/system/lootbox/boxes/${box.image}.png`} alt={box.name} />
                </div>

                <div className="line-fix">
                    <div className="line" ref={line}>
                        {box.preview.map((item_key, key) => {
                            const item = box.items[item_key];

                            return (
                                <div className={`item ${item.rarity}`} key={key}>
                                    <div className="rare"></div>
                                    <div className="image">
                                        <div className="blur"></div>
                                        <img src={`${window.location.origin}/source/system/lootbox/drops/${item.type}_${item.rarity}.png`} alt="" />
                                    </div>
                                    <div className="item_info">
                                        <div className="name">{item.name}</div>
                                        <div className="value">{item.value}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            <BlueButton active={button} onClick={e => {
                dispatch(openLoot(box.slug));
            }}>
                Open for <span><Diamond /> {box.price}</span>
            </BlueButton>
        </>
    )
}